import { defineStore } from 'pinia'
import { ref } from 'vue'
const useAlertStore = defineStore('alert', () => {
  const isOpenAlert = ref<boolean>(false)

  const openAlert = () => {
    isOpenAlert.value = true
  }

  const closeAlert = () => {
    isOpenAlert.value = false
  }
  return {
    isOpenAlert,
    openAlert,
    closeAlert,
  }
})

export { useAlertStore }
